module.exports = __webpack_public_path__ + "static/img/ranking_center_r.ec96ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_center_r.png
// module id = iRuJ
// module chunks = 0